import React from 'react';

const RightSide = () => {
    return <div>right</div>;
};

export default RightSide;
